import React, { useState } from 'react'
import { CommonCheckbox } from '@/components/common'
import {
  SubSection,
  StyledDemoGrid,
  DemoComponent,
  StyledSizeLabel,
} from '../styled.jsx'

export const CheckboxSection = () => {
  const [basicChecked, setBasicChecked] = useState(false)
  const [requiredChecked, setRequiredChecked] = useState(false)
  const [errorChecked, setErrorChecked] = useState(false)
  const [disabledChecked, setDisabledChecked] = useState(true)
  const [tooltipChecked, setTooltipChecked] = useState(false)

  return (
    <>
      {/* Basic Checkboxes */}
      <SubSection
        title='Checkbox Variants'
        description='Basic, required, error, disabled and with tooltip'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='Basic'
            component={
              <CommonCheckbox
                id='demo-checkbox-basic'
                label='Accept Terms'
                value={basicChecked}
                setValue={setBasicChecked}
              />
            }
            value={basicChecked}
          />
          <DemoComponent
            label='Required'
            component={
              <CommonCheckbox
                id='demo-checkbox-required'
                label='I agree to policy'
                value={requiredChecked}
                setValue={setRequiredChecked}
                required={true}
                helperText='This is required'
              />
            }
            value={requiredChecked}
          />
          <DemoComponent
            label='With Error'
            component={
              <CommonCheckbox
                id='demo-checkbox-error'
                label='Enable Feature'
                value={errorChecked}
                setValue={setErrorChecked}
                error='Selection is invalid'
              />
            }
            value={errorChecked}
          />
          <DemoComponent
            label='Disabled'
            component={
              <CommonCheckbox
                id='demo-checkbox-disabled'
                label='Disabled Option'
                value={disabledChecked}
                setValue={() => {}}
                disabled={true}
              />
            }
            value={disabledChecked}
          />
          <DemoComponent
            label='With Tooltip'
            component={
              <CommonCheckbox
                id='demo-checkbox-tooltip'
                label='Show Hints'
                value={tooltipChecked}
                setValue={setTooltipChecked}
                tooltip='Helpful information on hover'
              />
            }
            value={tooltipChecked}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Label Placements */}
      <SubSection
        title='Label Placement'
        description='Positions: end (default), start, top, bottom'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Placement Examples
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='End (Default)'
            component={
              <CommonCheckbox
                id='demo-checkbox-end'
                label='End Label'
                value={true}
                setValue={() => {}}
              />
            }
          />
          <DemoComponent
            label='Start'
            component={
              <CommonCheckbox
                id='demo-checkbox-start'
                label='Start Label'
                value={true}
                setValue={() => {}}
                labelPlacement='start'
              />
            }
          />
          <DemoComponent
            label='Top'
            component={
              <CommonCheckbox
                id='demo-checkbox-top'
                label='Top Label'
                value={true}
                setValue={() => {}}
                labelPlacement='top'
              />
            }
          />
          <DemoComponent
            label='Bottom'
            component={
              <CommonCheckbox
                id='demo-checkbox-bottom'
                label='Bottom Label'
                value={true}
                setValue={() => {}}
                labelPlacement='bottom'
              />
            }
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
